import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { PageNotFound } from "../../components/features/Errors/components";
import { FrontendUnexpectedError } from "../../components/features/Errors/components";

export function ErrorPage() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <PageNotFound />;
  }

  return <FrontendUnexpectedError />;
}
